import { render, staticRenderFns } from "./SliderTeaserSection.vue?vue&type=template&id=6d3db51c&"
import script from "./SliderTeaserSection.vue?vue&type=script&lang=js&"
export * from "./SliderTeaserSection.vue?vue&type=script&lang=js&"
import style0 from "./SliderTeaserSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports